import { render } from "./PropertySidebar.vue?vue&type=template&id=25d1e173"
import script from "./PropertySidebar.vue?vue&type=script&lang=js"
export * from "./PropertySidebar.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__